export default __webpack_public_path__ + "static/media/27-1.a84c32c5.mp3";